// Constants from meetings feature - these are simple values that don't change
export const activeValue = 'active'
export const hostValue = 'host'

const BASE_URL = {
  pending: '/api/scheduled_events/pending_events',
  scheduled: '/api/scheduled_events/events'
}

export const GET_MEETINGS = 'getMeetings'
export const GET_MEETING = 'getMeeting'
export const GET_INVITEES = 'getInvitees'

export const getBaseUrl = (selectedView: 'pending' | 'scheduled' = 'scheduled') => BASE_URL[selectedView]

// RTK Query cache tag types - ensure consistency across all API files
export const MEETING_TAG_TYPE = 'Meeting'
export const INVITEE_TAG_TYPE = 'Invitee'
export const MEETING_BUFFER_TAG_TYPE = 'MeetingBuffer'
export const MEETINGS_REALTIME_TAG_TYPE = 'MeetingsRealtime'
export const MEETING_RECAP_PAGE_TAG_TYPE = 'MeetingRecapPage'

// Special tag IDs
const LIST_TAG_ID = 'LIST'

// All tag types array for registration
export const MEETINGS_TAG_TYPES = [
  MEETING_TAG_TYPE,
  INVITEE_TAG_TYPE,
  MEETING_BUFFER_TAG_TYPE,
  MEETINGS_REALTIME_TAG_TYPE,
  MEETING_RECAP_PAGE_TAG_TYPE,
] as const

// Helper functions for building normalized cache tags
export const buildMeetingTag = (id: string | number) => ({
  type: MEETING_TAG_TYPE,
  id: String(id)
})

export const buildMeetingListTag = () => ({
  type: MEETING_TAG_TYPE,
  id: LIST_TAG_ID
})

export const buildMeetingBufferTag = (id: string | number) => ({
  type: MEETING_BUFFER_TAG_TYPE,
  id: String(id)
})

export const buildMeetingsRealtimeTag = (id?: string) => ({
  type: MEETINGS_REALTIME_TAG_TYPE,
  id: id || 'unified'
})
